import { endpoint } from 'src/constants';
import RequestSetting from 'src/interfaces/api/RequestSetting';
import { isDefinedOrThrowServerError } from 'src/utils';
import { apiClient } from 'src/utils/axios';

export const getRequestSetting = async (practiceId: number): Promise<RequestSetting> => {
  const response = await apiClient.get(endpoint('GET_REQUEST_SETTING', { practiceId }));
  return isDefinedOrThrowServerError(response.data);
};
